export interface ShareLink {
  tripId: string
  /** Opaque bearer token from the legacy `uno` query parameter. */
  userNo: string
}

export type TripStatus = 'running' | 'paused' | 'ended'
export type TripVisibility = 'private' | 'pals' | 'public' | 'unknown'

export interface TripPosition {
  id: string
  latitude: number
  longitude: number
  recordedAt: string
  altitudeMeters?: number
  accuracyMeters?: number
  speedMetersPerSecond?: number
  bearingDegrees?: number
  distanceKilometers?: number
  comment?: string
}

export interface TripDetails {
  id: string
  ownerName: string
  description?: string
  status: TripStatus
  visibility: TripVisibility
  startedAt: string
  endedAt?: string
  durationSeconds: number
  distanceKilometers: number
  averageSpeedKilometersPerHour: number
  platform?: string
  views?: number
  positions: TripPosition[]
}

export interface SharedTripApi {
  getSharedTrip(link: ShareLink, signal?: AbortSignal): Promise<TripDetails>
  /** Returns current trip metadata and only positions newer than `lastPositionId`. */
  refreshSharedTrip(link: ShareLink, lastPositionId: string, signal?: AbortSignal): Promise<TripDetails>
  /** Returns the backend-generated CSV when the share link grants access. */
  getSharedTripCsv(link: ShareLink, signal?: AbortSignal): Promise<Blob>
}

export type SharedTripApiErrorCode =
  | 'not-found-or-denied'
  | 'access-denied'
  | 'network'
  | 'invalid-response'

export class SharedTripApiError extends Error {
  constructor(
    readonly code: SharedTripApiErrorCode,
    message: string,
    options?: ErrorOptions,
  ) {
    super(message, options)
    this.name = 'SharedTripApiError'
  }
}
